var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCycleType(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type_of_Cycle",
    "data-name": "Type of Cycle",
    transform: "translate(23 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    transform: "translate(-23 21)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-bikecycle-4359616",
    transform: "translate(-26.865 24.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(9.835 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M30.435,7.042a.4.4,0,0,0-.538.18l-.8,1.6a.4.4,0,0,0,.357.58h.554l-.512,1.024a.4.4,0,1,0,.717.358l.8-1.6a.4.4,0,0,0-.358-.58H30.1l.512-1.024A.4.4,0,0,0,30.435,7.042Z",
    transform: "translate(-18.202 -4.995)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M21.24,29.014a4.771,4.771,0,0,0-2.338.609,2.919,2.919,0,0,1-.068-.62V27.638l1.379-.517a.956.956,0,0,0,.622-.913h0v-2a1.2,1.2,0,0,0-1.2-1.2H16.228a1,1,0,0,0,0,2h2.606v.574l-1.484.557a.806.806,0,0,0-.521.751v.925H11.063l-.4-.8h1.125a1.032,1.032,0,0,0,.1-2.06L10.4,24.8a1.2,1.2,0,0,0-1.386-.983,1.237,1.237,0,0,0-1,1.23v.759a1.2,1.2,0,0,0,1.2,1.2h.554l.583,1.166L9.266,29.691A4.811,4.811,0,1,0,11.6,34.227h.879a1.6,1.6,0,0,0,1.146,1.146v1.26a.4.4,0,0,0,.4.4h1.2v-.8h-.8v-.859a1.588,1.588,0,0,0,.823-2.571l1.689-2.366a3.778,3.778,0,0,0,.274.765,4.809,4.809,0,1,0,4.03-2.187ZM8.811,25.807v-.759a.434.434,0,0,1,.331-.438.418.418,0,0,1,.07-.006.4.4,0,0,1,.393.481.4.4,0,0,0,.353.481l1.854.185a.23.23,0,0,1-.023.456H9.212A.4.4,0,0,1,8.811,25.807Zm9.8,7.057L19.821,34a1,1,0,0,0,.686.272h.038a1,1,0,0,0,.7-.325,1.03,1.03,0,0,0-.071-1.424l-1.228-1.193a2.78,2.78,0,0,1,1.291-.314,2.826,2.826,0,1,1-2.631,1.844ZM16.028,24a.2.2,0,0,1,.2-.2h1.4v.4h-1.4A.2.2,0,0,1,16.028,24Zm2.406.2v-.4h1.2a.4.4,0,0,1,.4.4v1.077a1.016,1.016,0,0,0-.4.012V24.6a.4.4,0,0,0-.4-.4Zm-.8,2.684,2.165-.812a.207.207,0,0,1,.158.006.133.133,0,0,1,.073.075.164.164,0,0,1-.094.214l-1.639.615a.4.4,0,0,0-.26.376V29A3.775,3.775,0,0,0,19.172,31.7L20.619,33.1h0a.231.231,0,0,1,.04.306.2.2,0,0,1-.287.012l-1.809-1.7a2.967,2.967,0,0,1-.931-2.152Zm-.8,2.32L14.6,32.334a1.573,1.573,0,0,0-.425-.1l1.849-2.589a.4.4,0,0,0-.326-.636H12.19a.4.4,0,0,0-.347.6l1.567,2.714.01.012a1.6,1.6,0,0,0-.372.221.4.4,0,0,0-.046-.14l-1.569-2.717a.4.4,0,0,0-.328-.2.4.4,0,0,0-.346.168L8.817,32.39a.4.4,0,0,0,.326.634h3.5a1.576,1.576,0,0,0-.166.4H7.585l3.437-4.811H16.83Zm-3.037,2.182-.908-1.573h2.032Zm-1.834.833H9.922l1.127-1.577Zm-5.51,1.787a.4.4,0,0,0,.357.217H9.58a2.807,2.807,0,1,1-1.487-2.893L6.48,33.593a.4.4,0,0,0-.031.417Zm.357,3.826A4.01,4.01,0,1,1,8.8,30.347l-.238.334a3.6,3.6,0,1,0,1.831,3.546h.4a4.015,4.015,0,0,1-3.989,3.609Zm7.618-3.319v-.69h-.8v.69a.8.8,0,1,1,.8,0Zm6.816,3.319a4.01,4.01,0,0,1-3.547-5.877,3.641,3.641,0,0,0,.295.321A3.6,3.6,0,1,0,19.4,30.727a2.983,2.983,0,0,1-.213-.342,4.01,4.01,0,1,1,2.058,7.45Z",
    transform: "translate(-1.991 -14.58)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M48.193,49.939A1.6,1.6,0,0,0,50.129,47.6a.4.4,0,1,0-.682.421.8.8,0,0,1-.684,1.223.788.788,0,0,1-.284-.052.4.4,0,0,0-.286.749Z",
    transform: "translate(-29.514 -29.193)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M11.137,47.278a.4.4,0,0,0-.464-.655,1.6,1.6,0,0,0,1.47,2.819.4.4,0,1,0-.271-.754.813.813,0,0,1-.272.047.8.8,0,0,1-.463-1.457Z",
    transform: "translate(-6.785 -28.687)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M24.212,2a4.014,4.014,0,0,0-3.943,3.3l-.646-.43a.4.4,0,0,0-.445.667l1.2.8a.386.386,0,0,0,.043.02l.04.019a.357.357,0,0,0,.277,0l.04-.019a.386.386,0,0,0,.043-.02l1.2-.8a.4.4,0,0,0-.445-.667l-.468.312a3.205,3.205,0,0,1,5.752-.977.4.4,0,1,0,.663-.451A4.01,4.01,0,0,0,24.212,2Z",
    transform: "translate(-12.18 -2)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M23.7,12.232a.4.4,0,1,0-.718.357,4.01,4.01,0,0,0,7.585-1.445l.6.4a.4.4,0,0,0,.445-.667l-1.2-.8a.4.4,0,0,0-.268-.061.058.058,0,0,0-.02,0,.235.235,0,0,1-.028.009.361.361,0,0,0-.045.014.387.387,0,0,0-.14.077l-1.147.765a.4.4,0,1,0,.445.667l.557-.372a3.208,3.208,0,0,1-6.06,1.063Z",
    transform: "translate(-14.537 -6.797)",
    fill: "#00b26b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleType);
export default __webpack_public_path__ + "static/media/CycleType.895ba8370f178618d00b9b3b30c10113.svg";
export { ForwardRef as ReactComponent };